var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { HttpCssClient } from '../shared/http-request.interceptor';
import { Cookie } from '../shared/cookie.service';
import { CurrencyService } from '../shared/currency.service';
import { SuperInterceptor } from './super-interceptor.service';
import { HeaderService } from '../shared/header.service';
import { ɵgetDOM as getDOM } from '@angular/platform-browser';
/*import { HrefLang } from '../shared/angular2-hreflang';*/
///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>
var LanguageInterceptor = /** @class */ (function (_super) {
    __extends(LanguageInterceptor, _super);
    function LanguageInterceptor(router, translate, http, cookie, currencyService, headerService, platformId, document) {
        var _this = _super.call(this, router, cookie) || this;
        _this.router = router;
        _this.translate = translate;
        _this.http = http;
        _this.cookie = cookie;
        _this.currencyService = currencyService;
        _this.headerService = headerService;
        _this.platformId = platformId;
        _this.document = document;
        return _this;
    }
    ;
    LanguageInterceptor.prototype.canActivate = function (prev, next) {
        _super.prototype.canActivate.call(this, prev, next);
        var lang = 'en';
        //we need to differentiate between no language param and bad language param        
        if (prev.params['language'] != null && !this.checkValidLanguage(prev.params['language'])) {
            //bad languaje param
            this.router.navigate(['/oops/404']);
            return false;
        }
        else if (prev.params != null && this.checkValidLanguage(prev.params['language'])) {
            lang = prev.params['language'];
        }
        this.headerService.locale = lang;
        if (this.http.getHeader("LanguageCookie") != null) {
            this.http.removeHeader("LanguageCookie");
        }
        this.http.addHeader("LanguageCookie", lang);
        this.cookie.put("language", lang);
        this.translate.use(lang);
        try {
            if (!isPlatformBrowser(this.platformId)) {
                getDOM().setAttribute(this.document.head.parent, 'lang', lang);
            }
        }
        catch (ex) {
            //TODO: Esto falla en server side. Cambiar.
        }
        if (this.cookie.get()["guest_session"] != null && this.cookie.get()["guest_session"] != "undefined") {
            this.http.addHeader("Authorization", this.cookie.get()["guest_session"]);
        }
        if (this.cookie.get()['currency'] != null) {
            this.http.addHeader("CurrencyCookie", this.cookie.get()['currency']);
        }
        if (isPlatformBrowser(this.platformId)) {
            document.body.style.overflow = "auto";
            window.scrollTo(0, 0);
            //$('html, body').animate({scrollTop: '0px'}, 0)
        }
        ;
        return true;
    };
    LanguageInterceptor.prototype.checkValidLanguage = function (lang) {
        if (lang == 'es' || lang == 'en') {
            return true;
        }
        else {
            return false;
        }
    };
    return LanguageInterceptor;
}(SuperInterceptor));
export { LanguageInterceptor };
